export function QuoteFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M7.608 13.954c-.357.441-.777.859-1.255 1.265-.53.45-1.124.828-1.765 1.118a1 1 0 10.824 1.822 9.504 9.504 0 002.235-1.416C9.64 15.051 11 12.97 11 10a4 4 0 10-3.392 3.954zM16.353 15.219a9.593 9.593 0 001.255-1.265A4 4 0 1121 10c0 2.969-1.361 5.051-3.353 6.743a9.504 9.504 0 01-2.235 1.416 1 1 0 01-.824-1.822 7.504 7.504 0 001.765-1.118z"
      ></path>
    </svg>
  );
}
